import {
	BigNum,
	convertToNumber,
	PositionDirection,
	QUOTE_PRECISION_EXP,
	TEN_THOUSAND,
} from '@velocity-exchange/sdk';
import { MarketId } from '@velocity-exchange/common';
import { useEffect } from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';

export const useSyncLeverageAfterTrade = (
	tradeFormSide: 'buy' | 'sell',
	quoteSize: number,
	selectedMarketId: MarketId | undefined
) => {
	const currentUserClient = useDriftAccountStore(
		(s) => s.getCurrentUserAccount()?.client
	);
	const setState = useDriftStore((s) => s.set);

	/* Keep leverageAfterTrade intact */
	useEffect(() => {
		try {
			const leverageAfterTrade = (() => {
				if (!currentUserClient || !selectedMarketId) {
					return 0;
				}

				return convertToNumber(
					currentUserClient.accountLeverageRatioAfterTrade(
						selectedMarketId.marketIndex,
						selectedMarketId.marketType,
						BigNum.fromPrint(`${quoteSize}`, QUOTE_PRECISION_EXP).val,
						tradeFormSide === 'buy'
							? PositionDirection.LONG
							: PositionDirection.SHORT
					),
					TEN_THOUSAND
				);
			})();

			setState((s) => {
				s.tradeForm.leverageAfterTrade = leverageAfterTrade;
			});
		} catch (e) {
			console.error(e);
			setState((s) => {
				s.tradeForm.leverageAfterTrade = 0;
			});
		}
	}, [quoteSize, selectedMarketId, currentUserClient, tradeFormSide]);
};
